import React from 'react';
import {ThumbnailProps} from './MediaGalleryThumbnailFactory';
import ThumbnailProportional from './ThumbnailProportional';
import ThumbnailSquare from './ThumbnailSquare';

const ThumbnailGrid = ({...props}: ThumbnailProps) => {
  return (
    <>
      {props.thumbnailLayout === 'full-frame-tiles' && <ThumbnailProportional {...props} />}
      {props.thumbnailLayout === 'square-tiles' && <ThumbnailSquare {...props} />}
    </>
  );
};

export default ThumbnailGrid;
